/**
 * LOS CHEQUEOS DEL SISTEMA (SALUD-PANEL-T1; Josse 22-oct: validaciones versionadas que se repiten para que nada se
 * desborde).
 *
 * Lee GET /api/v1/salud/chequeos (contrato P #32446, A #32447): por chequeo la ultima corrida (codigo, version, nombre,
 * estado, frase, valor, unidad, motivo, hora) y las 24 anteriores. El nombre y la frase salen del catalogo de la base
 * (nexo_private.chequeos_catalogo): el panel no inventa textos, asi el MCP y el panel dicen lo mismo.
 *
 * ESTADOS: ok | warning | critical | unknown, los mismos de la base. unknown es "aun sin dato", NUNCA verde; un estado
 * que no se reconoce no se redondea a ninguno: se dice "estado sin leer".
 *
 * Sin DOM: lo prueba scripts/check-chequeos-salud.mjs.
 *
 * @module application/salud/chequeosSalud
 */

const de = (o, ...ks) => { for (const k of ks) if (o && o[k] !== undefined && o[k] !== null) return o[k]; return undefined; };
const texto = (v) => (v === undefined || v === null ? '' : String(v).trim());
const num = (v) => (v === undefined || v === null || v === '' || !Number.isFinite(Number(v)) ? null : Number(v));

export const ESTADOS = {
  ok: { texto: 'Verde', tono: 'ok' },
  warning: { texto: 'Amarillo', tono: 'ojo' },
  critical: { texto: 'Rojo', tono: 'mal' },
  unknown: { texto: 'Aun sin dato', tono: 'gris' }
};

/** El estado tal cual; uno desconocido no se disfraza de ninguno. */
export function estadoDe(e) {
  return ESTADOS[e] || { texto: 'Estado sin leer', tono: 'gris' };
}

export function normalizarChequeos(data) {
  const d = data || {};
  const items = Array.isArray(d) ? d : (Array.isArray(de(d, 'items', 'Items')) ? de(d, 'items', 'Items') : []);
  return items.map((x) => ({
    codigo: texto(de(x, 'codigo', 'check')),
    version: texto(de(x, 'version')),
    nombre: texto(de(x, 'nombre')) || texto(de(x, 'codigo', 'check')),
    estado: texto(de(x, 'estado', 'status')).toLowerCase(),
    frase: texto(de(x, 'frase')),
    valor: num(de(x, 'valor')),
    unidad: texto(de(x, 'unidad', 'unidades')),
    motivo: texto(de(x, 'motivo')),
    hora: texto(de(x, 'hora', 'source_cut')),
    incidenteAbierto: de(x, 'incidenteAbierto', 'incidente_abierto') === true,
    historial: (Array.isArray(de(x, 'historial')) ? de(x, 'historial') : []).map((h) => ({
      hora: texto(de(h, 'hora')), estado: texto(de(h, 'estado', 'status')).toLowerCase(), valor: num(de(h, 'valor'))
    }))
  }));
}

const ORDEN = { critical: 0, warning: 1, unknown: 2, ok: 3 };

/** Los peores primero: rojo, amarillo, sin dato, verde; un estado sin leer va con los sin dato. */
export function ordenarChequeos(items) {
  const o = (e) => (e in ORDEN ? ORDEN[e] : ORDEN.unknown);
  return [...items].sort((a, b) => o(a.estado) - o(b.estado) || a.codigo.localeCompare(b.codigo));
}

/**
 * La linea de arriba. Rojo manda, luego amarillo; "Todo en verde" solo si TODOS estan en ok. Con algun sin dato se dice
 * cuantos estan en verde y cuantos sin dato. La frase es la del primer chequeo del peor estado (la del catalogo).
 */
export function lineaResumen(items) {
  if (!items.length) return { texto: 'Aun no hay chequeos', tono: 'gris' };
  const de_ = (e) => items.filter((x) => x.estado === e);
  const conFrase = (lista) => lista[0].frase || lista[0].nombre;
  const rojos = de_('critical');
  if (rojos.length) return { texto: `${rojos.length} en rojo: ${conFrase(rojos)}`, tono: 'mal' };
  const amarillos = de_('warning');
  if (amarillos.length) return { texto: `${amarillos.length} en amarillo: ${conFrase(amarillos)}`, tono: 'ojo' };
  const verdes = de_('ok').length;
  if (verdes === items.length) return { texto: 'Todo en verde', tono: 'ok' };
  return { texto: `${verdes} de ${items.length} en verde, ${items.length - verdes} aun sin dato`, tono: 'gris' };
}
